import React, { Component } from 'react';
import { Button, Checkbox, Col, ControlLabel, FormControl, FormGroup, Grid, Modal, Radio } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';

import { KeyLicenseTypeNames, KeyLicenseTypes, OnlineLicenseTypes } from '../common/keyLicenseTypes';
import OverlayLoader from '../components/overlayLoader';
import * as permanentLicensesActions from '../store/permanentLicensesSlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import * as temporaryLicensesActions from '../store/temporaryLicensesSlice';
import { temporaryLicensesSelectors } from '../store/temporaryLicensesSlice';
import * as objectDataActions from '../store/objectDataSlice';
import { objectDataNames, objectDataSelectors } from '../store/objectDataSlice';
import { showModalMessage } from '../store/modalsSlice';
import { DATE_TIME_FORMAT } from '../common/dateTimeFormats';
import ExpirationDateEdit from '../components/expirationDateEdit';
import Row from 'react-bootstrap/lib/Row';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Create: '0',
  Edit: '1',
  Change: '2'
};

const getTitle = (type) => ({
  [Mode.Create]: `Create ${type && type.toLowerCase()} license`,
  [Mode.Edit]: "Edit license",
  [Mode.Change]: "Change license"
});

const SubmitButtonCaptions = {
  [Mode.Create]: "Create",
  [Mode.Edit]: "Save",
  [Mode.Change]: "Change"
};

const TemporaryLicensePeriodMonthCount = 1;
const TemporaryLicensePeriodYearsCount = 1;

class KeyLicenseEditDialog extends Component {
  initState = {
    licKeyType: '',
    productLicKeyTypes: [],
    productName: '',
    features: [],
    term: null,
    startDate: null,
    temporalType: KeyLicenseTypes.OnlinePermanent,
    clientId: null,
    licenseCount: 1,
    supportDayCount: null,
    obtainingMethod: 'free'
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onShow = this.onShow.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onLicKeyTypeChanged = this.onLicKeyTypeChanged.bind(this);
    this.onFeaturesChanged = this.onFeaturesChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onProductNameChanged = this.onProductNameChanged.bind(this);
    this.onTemporalTypeChanged = this.onTemporalTypeChanged.bind(this);
    this.onTermChanged = this.onTermChanged.bind(this);
    this.onLicenseCountChanged = this.onLicenseCountChanged.bind(this);
    this.getErrorPropName = this.getErrorPropName.bind(this);
    this.onSupportDayCountChanged = this.onSupportDayCountChanged.bind(this);
  }

  static get Mode() {
    return Mode;
  }

  onShow() {
    this.setState(this.initState);
    if (this.props.mode === Mode.Create) {
      if (this.props.temporalType !== undefined)
        this.setState({ temporalType: this.props.temporalType });
      else {
        this.setState({ temporalType: KeyLicenseTypes.OnlinePermanent });
      }
      if (this.props.clientId !== undefined)
        this.setState({ clientId: this.props.clientId });

      let m = moment();
      this.setState({ startDate: m });
      this.setState({ term: m.clone().add('months', TemporaryLicensePeriodMonthCount).diff(m, 'days') });
      this.setState({ supportDayCount: m.clone().add('years', TemporaryLicensePeriodYearsCount).diff(m, 'days') });
    } else if (this.props.mode === Mode.Edit || this.props.mode === Mode.Change) {
      if (this.props.productName !== undefined)
        this.setState({ productName: this.props.productName });
      if (this.props.licKeyType !== undefined)
        this.setState({ licKeyType: this.props.licKeyType });
      if (this.props.selectedFeatures !== undefined)
        this.setState({ features: this.props.selectedFeatures });
      if (this.props.temporalType !== undefined)
        this.setState({ temporalType: this.props.temporalType });
      if (this.props.generationDate !== undefined)
        this.setState({ startDate: moment(this.props.generationDate, DATE_TIME_FORMAT) });
      if (this.props.term !== undefined)
        this.setState({ term: this.props.term });
      if (this.props.clientId !== undefined)
        this.setState({ clientId: this.props.clientId });
      if (this.props.supportDayCount !== undefined)
        this.setState({ supportDayCount: this.props.supportDayCount });
    }

    this.props.fetchLicKeyTypes()
      .then(unwrapResult)
      .then(() => {
        if (this.props.mode === Mode.Change) {
          this.setState({ licKeyType: this.getNewLicKeyType() });
        }
        if (this.getOnlineLicKeyTypes().length > 0) {
          let product = this.props.mode === Mode.Create ?
            this.getOnlineLicKeyTypes()[0] :
            this.getOnlineLicKeyTypes().find(product => product.productName === this.props.productName);
          if (product === undefined)
            return;
          this.props.fetchFeatures(product.productName)
            .then(unwrapResult)
            .catch(() => {
              this.onClose();
              this.props.showModalMessage("Error", this.props.featuresState.error.toString());
            });
          this.setState({ productLicKeyTypes: product.licenseTypes });
          if (this.props.mode === Mode.Create) {
            if (product.licenseTypes.length > 0)
              this.setState({ licKeyType: product.licenseTypes[0].code });
            this.setState({ productName: product.productName });
          }
        }
      }).catch(() => {
      this.onClose();
      this.props.showModalMessage("Error", this.props.licenseKeyTypesState.error.toString());
    });
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState)
  }

  getOnlineLicKeyTypes() {
    return this.props.licenseKeyTypesState.data.map(licKeyType => ({
      ...licKeyType,
      licenseTypes: licKeyType.licenseTypes.filter(type => type.online && !type.deprecated)
    })).filter(licKeyType => licKeyType.licenseTypes.length > 0);
  }

  onLicKeyTypeChanged(e) {
    this.setState({ licKeyType: e.target.value });
  }

  onProductNameChanged(e) {
    this.setState({ productName: e.target.value });
    this.setState({ features: [] });
    let product = this.getOnlineLicKeyTypes().find(
      prodLicKeyType => prodLicKeyType.productName === e.target.value
    );
    if (product === undefined) {
      this.setState({ licKeyType: "" });
      return;
    }
    this.props.fetchFeatures(e.target.value).then(unwrapResult).catch(() => {
      this.onClose();
      this.props.showModalMessage("Error", this.props.featuresState.error.toString());
    });
    this.setState({ productLicKeyTypes: product.licenseTypes });
    if (product.licenseTypes.length > 0)
      this.setState({ licKeyType: product.licenseTypes[0].code });
    else
      this.setState({ licKeyType: "" });
  }

  onObtainingMethodChange(e) {
    this.setState({ obtainingMethod: e.target.value });
  }

  onFeaturesChanged(checked, featureId) {
    this.setState({
      features: checked ?
        [...this.state.features, featureId] :
        this.state.features.filter(fid => fid !== featureId)
    });
  }

  onTemporalTypeChanged(e) {
    this.setState({ temporalType: e.target.value });
  }

  onTermChanged(value) {
    this.setState({ term: value });
  }

  onSupportDayCountChanged(count) {
    const re = /^\d+$/;
    if (count.length === 0 || !re.test(count)) {
      this.setState({ supportDayCount: null });
      return;
    }
    this.setState({ supportDayCount: parseInt(count, 10) });
  }

  onLicenseCountChanged(count) {
    const re = /^\d+$/;
    if (count.length === 0 || !re.test(count)) {
      this.setState({ licenseCount: null });
      return;
    }
    this.setState({ licenseCount: parseInt(count, 10) });
  }

  isLodaing() {
    return this.props.licenseKeyTypesState.isFetching ||
      this.props.featuresState.isFetching;
  }

  getLoaderMessage() {
    if (this.props.licenseKeyTypesState.isFetching) {
      return "License key types loading...";
    }
    if (this.props.featuresState.isFetching) {
      return "Features loading...";
    }
  }

  isLicKeyTypesDisabled() {
    return this.props.mode !== Mode.Create;
  }

  isProductNameDisabled() {
    return this.props.mode !== Mode.Create;
  }

  isFeaturesVisible() {
    return this.props.featuresState.data !== null && this.props.featuresState.data.length > 0;
  }

  isSubmitButtonDisabled() {
    return this.isLodaing() ||
      this.state.licKeyType.length === 0 || (
        this.props.mode === Mode.Create &&
        this.state.temporalType === KeyLicenseTypes.OnlineTemporary &&
        this.state.term === 0
      ) || (
        this.props.mode === Mode.Edit && ((
          (this.state.temporalType === KeyLicenseTypes.OnlinePermanent &&
            this.isFeatArrayEquals(this.state.features, this.props.selectedFeatures)) &&
          this.props.supportDayCount === this.state.supportDayCount
        ) || (
          this.state.temporalType === KeyLicenseTypes.OnlineTemporary &&
          this.props.term === this.state.term &&
          this.isFeatArrayEquals(this.state.features, this.props.selectedFeatures)
        ))
      ) || (
        (this.props.mode === Mode.Create || this.props.mode === Mode.Change) &&
        (this.state.supportDayCount === null || this.state.supportDayCount < 0)
      ) || (
        this.props.mode === Mode.Create && this.state.licenseCount <= 0
      );
  }

  isFeatArrayEquals(r, l) {
    if (r.length !== l.length) {
      return false;
    }
    r.sort();
    l.sort();
    for (let i = 0; i < r.length; ++i) {
      if (r[i] !== l[i]) {
        return false;
      }
    }
    return true;
  }

  getOnSubmitPromise() {
    switch (this.props.mode) {
      case Mode.Create:
        return this.getCreatePromise();
      case Mode.Edit:
        return this.getUpdatePromise();
      case Mode.Change:
        return this.getChangePromise();
      default:
        return null;
    }
  }

  getCreatePromise() {
    const { clientId, productName, licKeyType, features, supportDayCount, licenseCount, term, obtainingMethod } = this.state;
    let promise = null;
    switch (this.state.temporalType) {
      case KeyLicenseTypes.OnlinePermanent:
        promise = this.props.createNewPermanentLicenses({
          clientId, productName, type: licKeyType,
          features, supportDayCount, licenseCount
        });
        break;
      case KeyLicenseTypes.OnlineTemporary:
        promise = this.props.createNewTemporaryLicenses({
          clientId, productName, type: licKeyType, features, obtainingMethod,
          term, licenseCount
        });
        break;
      default:
        return null;
    }
    if (promise === null)
      return null;
    return promise.then(unwrapResult).then(lics => this.props.showModalMessage(
      `License${lics.length > 1 ? 's' : ''} created`, `${lics.map(lic => lic.key).join('\n')}`
    ));
  }

  getUpdatePromise() {
    const { features, supportDayCount, term } = this.state;
    const { licenseId } = this.props;
    switch (this.state.temporalType) {
      case KeyLicenseTypes.OnlinePermanent:
        return this.props.updatePermanentLicense({
          licenseId, features, supportDayCount
        });
      case KeyLicenseTypes.OnlineTemporary:
        return this.props.updateTemporaryLicense({
          licenseId, features, term,
        });
      default:
        return null;
    }
  }

  getChangePromise() {
    const { features, supportDayCount, productName, licKeyType } = this.state;
    const { licenseId } = this.props;

    switch (this.state.temporalType) {
      case KeyLicenseTypes.OnlinePermanent:
        return this.props.changePermanentLicense({
          productName, type: licKeyType, licenseId, features, supportDayCount
        })
          .then(unwrapResult)
          .then(permanentLicenses => this.props.showModalMessage("License changed", `Next license: ${permanentLicenses[1].key}`));
      default:
        return null;
    }
  }

  getErrorPropName() {
    switch (this.props.temporalType) {
      case KeyLicenseTypes.OnlinePermanent:
        return 'permanentLicensesError';
      case KeyLicenseTypes.OnlineTemporary:
        return 'temporaryLicensesError';
      default:
        return null;
    }
  }

  onSubmit() {
    this.onClose();
    let submitPromise = this.getOnSubmitPromise();

    if (submitPromise == null) {
      this.props.showModalMessage("Error", "Unknown dialog mode or key license type");
      return;
    }

    submitPromise
      .then(unwrapResult)
      .catch(() => {
        this.props.showModalMessage(
          "Error", this.props.onSubmitError[this.getErrorPropName()].toString()
        );
      });
  }

  getNewLicKeyType() {
    const productName = this.props.productName;
    let licKeyType = this.getOnlineLicKeyTypes().find(type => type.productName === productName);
    if (licKeyType === undefined)
      return '';
    if (licKeyType.licenseTypes.length === 0)
      return '';
    return licKeyType.licenseTypes[0].code;
  }

  render() {
    const permanentValidTerm = !this.props.supportDayCount && this.props.supportDayCount !== 0
      ? this.state.supportDayCount
      : this.props.supportDayCount;
    return (
      <Modal show={this.props.show} onShow={this.onShow} onHide={this.onClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>{getTitle(KeyLicenseTypeNames[this.props.temporalType])[this.props.mode]}</Modal.Title>
      </Modal.Header>
				<Modal.Body>
        <OverlayLoader
            active={this.isLodaing()}
            text={this.getLoaderMessage()}
          >
            <Grid fluid className="noPadding">
              <Row className="noMargin">
                {this.state.clientId === null ? null :
                  <FormGroup controlId="fcClientName">
                    <ControlLabel>Client name</ControlLabel>
                    <FormControl.Static>{this.props.clientName}</FormControl.Static>
                  </FormGroup>
                }
							</Row>
              {this.props.temporalType !== undefined ? null :
                <FormGroup controlId="fcTemporalType">
                  <ControlLabel>Temporal type</ControlLabel>
                  <Row className="noMargin"> {
                    OnlineLicenseTypes.map(typeKey => {
                      return (
                        <Col sm={4} md={4} lg={4} className="noPadding" key={typeKey}>
                          <Radio
                            onChange={this.onTemporalTypeChanged}
                            checked={this.state.temporalType === typeKey}
                            value={typeKey}
                          >
                            {KeyLicenseTypeNames[typeKey]}
                          </Radio>
                        </Col>
                      )
                    })
                  } </Row>
                </FormGroup>
              }
					     <Row className="noMargin edit-lic-margin-top">
              <Col sm={6} md={6} lg={6} className="noPadding">
                  <FormGroup controlId="fcProdName">
                    <ControlLabel>Product name</ControlLabel>
                    <FormControl
                      componentClass="select"
                      placeholder="Product name"
                      value={this.state.productName}
                      onChange={this.onProductNameChanged}
                      disabled={this.isProductNameDisabled()}
                    >
                      {this.getOnlineLicKeyTypes().map(prodLicKeyType => {
                        return (
                          <option key={prodLicKeyType.productName}
                                  value={prodLicKeyType.productName}>{prodLicKeyType.productName}</option>
                        );
                      })}
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col sm={6} md={6} lg={6}>
                  <FormGroup controlId="fcLicKeyType">
                    <ControlLabel>License key type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      placeholder="License key type"
                      value={this.state.licKeyType}
                      onChange={this.onLicKeyTypeChanged}
                      disabled={this.isLicKeyTypesDisabled()}
                    >
                      {this.state.productLicKeyTypes.map(type => {
                        return (
                          <option key={type.code} value={type.code}>{type.name}</option>
                        );
                      })}
                    </FormControl>
                  </FormGroup>
                </Col>
							</Row>
              <Row className="noMargin edit-lic-margin-top">
                {this.state.temporalType !== KeyLicenseTypes.OnlineTemporary ? null :
                  <FormGroup controlId="fgLicensePeriod">
										<ControlLabel>License period</ControlLabel>
										<ExpirationDateEdit
											startDate={this.state.startDate}
											term={this.props.term || this.state.term}
											onChange={this.onTermChanged}
											elementType={'licensePeriod'}
										/>
									</FormGroup>
								}
                {this.state.temporalType !== KeyLicenseTypes.OnlinePermanent ? null :
                  <Col sm={10} md={10} lg={10} className="noPadding">
                    <FormGroup controlId="fgSupportDayCount">
											<ControlLabel>Support day count</ControlLabel>
											<ExpirationDateEdit
												startDate={this.props.generationDateTime || this.state.startDate}
												term={permanentValidTerm}
												onChange={this.onSupportDayCountChanged}
												elementType={'supportDayCount'}
											/>
										</FormGroup>
									</Col>
								}
							</Row>
              <Row className="noMargin edit-lic-margin-top">
                {this.isFeaturesVisible() ? (
                  <Col sm={12} md={12} lg={12} className="noPadding">
                    <FormGroup controlId="fcPermLicFeatures" disabled>
                      <ControlLabel>Features</ControlLabel>
                      <Row className="noMargin">
                        {this.props.featuresState.data.map(feature => {
                          return (
                            <Col sm={6} md={6} lg={6} key={feature.id}
                                 className="noPadding perm-lic-features-collection-item">
                              <Checkbox
                                onChange={e => this.onFeaturesChanged(e.target.checked, feature.id)}
                                checked={this.state.features.includes(feature.id)}
                              >
                                {feature.name}
                              </Checkbox>
                            </Col>
                          );
                        })}
                      </Row>
										</FormGroup>
									</Col>
								) : null}
							</Row>
              <Row className="noMargin edit-lic-margin-top">
                {this.props.mode === Mode.Create ? (
                  <Col sm={4} md={4} lg={4} className="noPadding">
                    <FormGroup controlId="fcLicenseCount">
                      <ControlLabel>License count</ControlLabel>
                      <FormControl value={this.state.licenseCount} type="number" min="1"
                                   onChange={e => this.onLicenseCountChanged(e.target.value)} />
                    </FormGroup>
                  </Col>
                ) : null}
              </Row>
						</Grid>
					</OverlayLoader>
				</Modal.Body>
				<Modal.Footer>
        <Button
            onClick={this.onSubmit}
            disabled={this.isSubmitButtonDisabled()}
          >
						{SubmitButtonCaptions[this.props.mode]}
					</Button>
					<Button onClick={this.onClose}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
  }
}

function mapStateToProps(state) {
  return {
    licenseKeyTypesState: objectDataSelectors.licenseKeyTypesState(state),

    featuresState: objectDataSelectors.featuresState(state),

    onSubmitError: {
      permanentLicensesError: permanentLicensesSelectors.creatingUpdatingChangingError(state),
      temporaryLicensesError: temporaryLicensesSelectors.creatingUpdatingError(state)
    }
  };
}

const actionCreators = {
  fetchLicKeyTypes: () => objectDataActions.fetchObjectData({ objectName: objectDataNames.licenseKeyTypes }),
  fetchFeatures: (productName) => objectDataActions.fetchObjectData({
    objectName: objectDataNames.features,
    field: productName
  }),

  createNewPermanentLicenses: permanentLicensesActions.create,
  updatePermanentLicense: permanentLicensesActions.update,
  changePermanentLicense: permanentLicensesActions.change,

  createNewTemporaryLicenses: temporaryLicensesActions.create,
  updateTemporaryLicense: temporaryLicensesActions.update,

  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(KeyLicenseEditDialog);



// WEBPACK FOOTER //
// ./src/containers/keyLicenseEditDialog.js